import MetalSynth from 'instruments/MetalSynth.js';
import ParameterContext from 'effects/ParameterContext.js';
import InstrumentTrack from './InstrumentTrack.js';

class MetalSynthTrack extends InstrumentTrack {
    constructor(trackNumber, sequencerEngine, mixSession, numberOfPatterns, update, subSequence) {
        super(trackNumber, sequencerEngine, mixSession, numberOfPatterns, update, subSequence);
        this.setInstrument(
            new MetalSynth(
                sequencerEngine,
                mixSession,
                new ParameterContext().forTrack(this)));
    }
}

export default MetalSynthTrack;
